import React from "react";
import ReactDOM from "react-dom/client";
import { HashRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import { ThemeModeProvider } from "./components/ThemeModeProvider";
import { SnackbarProvider } from "./components/ui/SnackbarProvider";
import { AuthProvider } from "./auth/AuthContext";
import { CustomerProvider } from "./components/CustomerProvider";
import { captureAuthRedirect } from "./auth/redirectHash";
import { loadMeta } from "./lib/states";
import "./i18n";
import "./index.css";

// The identity provider answers in the URL fragment, which HashRouter
// rewrites as soon as it mounts. Take it before React renders.
captureAuthRedirect();

// Fetch /api/meta once (state map, upload cap, poll intervals). Falls back
// to the built-ins when the endpoint does not exist yet.
void loadMeta();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { refetchOnWindowFocus: false },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ThemeModeProvider>
      <QueryClientProvider client={queryClient}>
        <SnackbarProvider>
          {/* HashRouter: the SPA is served as a single index.html behind Caddy;
              hash routes need no server-side history fallback. */}
          <HashRouter>
            <AuthProvider>
              <CustomerProvider>
                <App />
              </CustomerProvider>
            </AuthProvider>
          </HashRouter>
        </SnackbarProvider>
      </QueryClientProvider>
    </ThemeModeProvider>
  </React.StrictMode>,
);
